module.exports = __webpack_public_path__ + "img/laboratorio2_16-9_2880.48ee4aec.webp";